import * as React from 'react';
import styled from '@emotion/styled';
import { L } from '../../../../../lib/i18n';
import { Profession } from '@app/api/models/AccountSettings';
import { Checkbox } from '../../../../../components/Checkbox/Checkbox';
import { MultiSelect } from '../../../../../components/Dropdown/MultiSelect';
import DropdownFlexContainer from './DropdownFlexContainer';

const Container = styled.div({ paddingRight: '10px' });

interface Props {
    filter: { profession?: number[] };
    setFilter: (filter: any) => void;
    store: { professions: Profession[]; load(): Promise<void> };
}

export const FilterProfession = (props: Props) => {
    const name = 'profession';

    const handleOnChange = value => {
        event?.preventDefault();
        props.setFilter({
            ...props.filter,
            [name]: [...new Set<string>(value?.flatMap(id => id.value))]
        });
    };

    const options = props.store.professions.map(v => ({
        value: v.id,
        label: (
            <DropdownFlexContainer>
                <Checkbox onChange={() => handleOnChange} checked={props.filter[name]?.includes(v.id) || false} />
                <span>{v.name}</span>
            </DropdownFlexContainer>
        )
    }));

    const selectAll = [
        {
            value: props.store.professions?.map(profession => profession.id),
            label: ' Välj alla'
        },
        ...options
    ];

    return (
        <Container>
            <MultiSelect
                isMulti={true}
                isClearable
                value={props.filter[name]?.map(id => ({
                    value: id,
                    label: props.store.professions?.find(({ id: profession_id }) => profession_id === +id)?.name
                }))}
                onChange={handleOnChange}
                name={name}
                label={L(name)}
                options={selectAll}
            />
        </Container>
    );
};
